import { z } from 'zod'
import { parseRequestError } from '@/common/utilities.ts'
import axios from 'axios'

const StateDetailsSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string(),
  country: z.string(),
  timezone: z.string(),
})

export type StateDetails = z.infer<typeof StateDetailsSchema>

export const getStateDetail = async (
  stateId?: number | null
): Promise<StateDetails> => {
  try {
    const response = await axios.get(`states/${stateId}`)
    return StateDetailsSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}
